import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { formatDate } from '../../../CommonUtils/formatDate';
import { Dot } from '../../../CommonComponents/OPL/Dot/Dot';
import { Link } from '../../../CommonComponents/OPL/Link/Link';
import { Lozenge } from '../../../CommonComponents/OPL/Lozenge/Lozenge';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { PostDTO, PostTypeDTO } from '../../api/useNewsfeedQuery';
import { Content } from './Post.styles';

interface Props {
  post: PostDTO;
}

export const Post: React.FC<Props> = ({ post }) => {
  const { title, date, content, isNew, link, caption, type } = post;

  return (
    <>
      <Box display="flex" justifyContent="space-between" mb="4">
        <Text variant="cardTitle">{title}</Text>

        {isNew && <Lozenge variantColor="new">New</Lozenge>}
      </Box>

      <Box display="flex" alignItems="center" mb="16">
        <Text fontSize="small" color="neutral.500">
          {formatDate(date)}
        </Text>

        <Dot bg="neutral.500" size={4} mx="4" />

        {type !== null && <Lozenge>{PostTypeDTO[type]}</Lozenge>}
      </Box>

      {caption && <Text>{caption}</Text>}

      {content && <Content dangerouslySetInnerHTML={{ __html: content }} />}

      {link && (
        <Box>
          <Link
            href={link}
            isExternal
            mt="16"
            rel="noopener noreferrer"
            target={type === PostTypeDTO.Statement ? '_self' : '_blank'}
          >
            Supporting Link
          </Link>
        </Box>
      )}
    </>
  );
};
